import { render, staticRenderFns } from "./receipt-off-popup.vue?vue&type=template&id=8c87c21e"
import script from "./receipt-off-popup.vue?vue&type=script&lang=js"
export * from "./receipt-off-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports